import { TeamAccessDTO } from '../team/team-access.dto';

export class ContactListDTO extends TeamAccessDTO {

    id: string;

    firstName: string;

    lastName: string;

    image: string;

    email: string;

    phone: string;

    cellPhone: string;

}
